module.exports = __webpack_public_path__ + "img/gs90-3.e639ab56.jpg";